import React from 'react';

import PropTypes from 'prop-types';

import './CheckBox.less';
/**
 * onchange on checkbox not fired, because of htmlFor in label
 * @link https://stackoverflow.com/questions/46993591/react-why-label-not-firing-onchange-for-checkbox
 */
function CheckBox({text, id, onChange, value}) {
  const containerStyle = {
    'justify-content': 'left',
    left: '50px',
    'margin-top': '30px',
  };

  return (
    <label
      htmlFor={id}
      className="container"
      style={containerStyle}
    >
      {text}
      <input
        id={id}
        onChange={(e) => onChange(e)}
        value={value}
        checked={value}
        type="checkbox"
        name={id}
      />
      <span className="checkmark" />
    </label>
  );
}

CheckBox.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.bool,
  id: PropTypes.string,
  text: PropTypes.string,
};

CheckBox.defaultProps = {
  text: '',
  id: '',
  value: false,
  onChange: () => {},
};
export default CheckBox;
